const isEven = (number: number): boolean => {
  return number % 2 === 0
}

export default isEven
